<div class="no-revision">
  <h5>{{type}}</h5>
  <ng-container *ngIf="!isFordPass && !isPerks">
    <p>{{'history-schedule.service' | translate}}</p>
    <lib-button type="primary" [rightIcon]="true" (clickButton)="redirectTo()">{{'schedule' | translate}}</lib-button>
  </ng-container>
</div>
